import type { CountryCode } from 'libphonenumber-js';

const flagModules = import.meta.glob('/resources/js/assets/country-flags/*.svg', {
    eager: true,
    query: '?url',
    import: 'default',
});

const matchCountryCodeRegex = /([A-Z]{2})\.svg$/;

export const countryFlags = new Map<CountryCode, string>(
    Object.entries(flagModules)
        .map(([path, url]) => {
            const countryCode = path.match(matchCountryCodeRegex);
            return [countryCode?.[1], url] as const;
        })
        .filter((entry): entry is [CountryCode, string] => !!entry[0]),
);
